class LookbookCarousel {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('[data-lookbook-track]');
    this.slides = [...section.querySelectorAll('[data-lookbook-slide]')];
    this.prevBtn =
      section.querySelector('[data-prev]') ||
      section.querySelector('[ref="previous"]');
    this.nextBtn =
      section.querySelector('[data-next]') ||
      section.querySelector('[ref="next"]');

    this.currentIndex = 1;
    this.isAnimating = false;
    this.interval = null;
    this.duration = 4500;

    if (!this.track || this.slides.length < 2) return;

    this.setup();
    this.bind();
    this.startAutoplay();
  }

  setup() {
    // Clone first & last slides
    const firstClone = this.slides[0].cloneNode(true);
    const lastClone = this.slides[this.slides.length - 1].cloneNode(true);

    firstClone.setAttribute('data-clone', 'true');
    lastClone.setAttribute('data-clone', 'true');

    this.track.insertBefore(lastClone, this.slides[0]);
    this.track.appendChild(firstClone);

    this.allSlides = [...this.track.children];

    // Initial position (first real slide)
    this.track.style.transform = `translateX(-100%)`;
  }

  bind() {
    this.nextBtn?.addEventListener('click', () => {
      this.next();
      this.restartAutoplay();
    });

    this.prevBtn?.addEventListener('click', () => {
      this.prev();
      this.restartAutoplay();
    });

    this.track.addEventListener('transitionend', () => {
      this.onTransitionEnd();
    });

    this.section.addEventListener('mouseenter', () => this.stopAutoplay());
    this.section.addEventListener('mouseleave', () => this.startAutoplay());
  }

  startAutoplay() {
    if (this.interval) return;
    this.interval = setInterval(() => this.next(), this.duration);
  }

  stopAutoplay() {
    clearInterval(this.interval);
    this.interval = null;
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }

  next() {
    if (this.isAnimating) return;
    this.isAnimating = true;
    this.currentIndex++;
    this.move();
  }

  prev() {
    if (this.isAnimating) return;
    this.isAnimating = true;
    this.currentIndex--;
    this.move();
  }

  move() {
    this.track.style.transition = 'transform 0.5s ease';
    this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
  }

  onTransitionEnd() {
    this.isAnimating = false;

    // If we hit the cloned slides, jump instantly
    if (this.currentIndex === this.allSlides.length - 1) {
      this.track.style.transition = 'none';
      this.currentIndex = 1;
      this.track.style.transform = `translateX(-100%)`;
    }

    if (this.currentIndex === 0) {
      this.track.style.transition = 'none';
      this.currentIndex = this.allSlides.length - 2;
      this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
    }
  }
}

/* Mount */
const mountLookbook = (root = document) => {
  root.querySelectorAll('[data-lookbook-carousel]').forEach(section => {
    if (section.__mounted) return;
    section.__mounted = true;
    new LookbookCarousel(section);
  });
};

document.addEventListener('DOMContentLoaded', () => mountLookbook());
document.addEventListener('shopify:section:load', e =>
  mountLookbook(e.target)
);
